import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import * as Common from './assets/js/common.js'
import echarts from 'echarts'

import  mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

Vue.use(mavonEditor)
Vue.use(ElementUI) //引入element-ui
Vue.prototype.$axios = axios //将axios方法写在Vue实例的原型上
Vue.prototype.$common = Common;
Vue.config.productionTip = false //生产环境提示
Vue.prototype.$echarts = echarts


new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
